import {
  LOGIN_SUCCESS,
  USER_FETCH,
  USER_FETCH_SUCCESS,
  USER_FETCH_FAIL,
  USER_SAVE,
  USER_SAVE_SUCCESS,
  USER_SAVE_FAIL,
  LOGOUT
} from '../constants/ActionTypes';

const initialState = {
  data: {},
  loading: true,
  errors: [],
  userID: null,
  partnerID: null,
  organizationID: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        userID: action.payload.userID
      }
    case USER_FETCH:
      return {
        ...state,
        loading: true
      };
    case USER_FETCH_SUCCESS: {
      let partnerID;
      const stroredPartnerID = localStorage.getItem('partnerID');

      if (stroredPartnerID) {
        const partner = action.user.partners.find(p => p.partnerID === stroredPartnerID);
        partnerID = partner ? partner.partnerID : action.user.partners[0].partnerID
      } else {
        partnerID = action.user.partners[0].partnerID;
      } 

      localStorage.setItem('partnerID', partnerID);
      return {
        ...state,
        data: { ...action.user },
        userID: action.user.userID,
        partnerID: state.partnerID || partnerID,
        organizationID: action.user.organizationID,
        loading: false,
        errors: initialState.errors
      };
    };
    case USER_FETCH_FAIL:
      return {
        ...state,
        data: {},
        loading: false,
        errors: action.errors
      };
    case USER_SAVE:
      return {
        ...state,
        loading: true,
        errors: initialState.errors
      };
    case USER_SAVE_SUCCESS: {
      const { isCurrentUser } = action;
      let data = { ...state.data };

      if (isCurrentUser) {
        data = { ...action.payload };
      }

      return {
        ...state,
        data,
        loading: false,
        errors: initialState.errors
      };
    }
    case USER_SAVE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.erros
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
